import { render } from "./upload-rooms.vue?vue&type=template&id=1df86657&scoped=true&lang=pug"
import script from "./upload-rooms.vue?vue&type=script&lang=js"
export * from "./upload-rooms.vue?vue&type=script&lang=js"

import "./upload-rooms.vue?vue&type=style&index=0&id=1df86657&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df86657"]])

export default __exports__